function setCookie(name, value) {
    document.cookie = `${name}=${value}; expires=${new Date(Date.now() + 23 * 60 * 60 * 1000).toUTCString()}; path=/; SameSite=Strict`;
}

export default setCookie;